// components/OrderConfirmation.js
import React from 'react';
import { Box, Text, Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

const OrderConfirmation = () => {

  const navigate = useNavigate();
  const handleContinueShopping = () => {
    navigate('/'); // Navigate to home or shop page
  };
  
  return (
    <Box p={4} textAlign="center">
      <Text fontSize="3xl" mb={4}>Purchase Confirmation</Text>
      <Text fontSize="xl" mb={4}>Boom! You just bought a piece of the beat.</Text>
      <Text fontSize="lg" mb={4}>Earn by listening to your tracks.</Text>
      <Button colorScheme="teal" py={6} onClick={handleContinueShopping}>Browse More Music</Button>
    </Box>
  );
};

export default OrderConfirmation;
